import { makeStyles } from '@mui/styles';
import { COLORS } from '../../../shared/config/colors';

const useStyles = makeStyles((theme) => ({
  inputField: {
    width: '100%',
  },
  containerGrid: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  actionButtons: {
    position: 'absolute',
    right: '-50px',
    bottom: '5px'
  },
  addCondition: {
    color: COLORS.BLUE,
    fontWeight: 'bold',
    fontSize: '16px',
    cursor: 'pointer',
  }
}));

export default useStyles;
